export const GET_WORK_ORDERS_START = 'GET_WORK_ORDERS_START';
export const GET_WORK_ORDERS_FAIL = 'GET_WORK_ORDERS_FAIL';
export const GET_WORK_ORDERS_SUCCESS = 'GET_WORK_ORDERS_SUCCESS';
export const ADD_WORK_ORDER_START = 'ADD_WORK_ORDER_START';
export const ADD_WORK_ORDER_FAIL = 'ADD_WORK_ORDER_FAIL';
export const ADD_WORK_ORDER_SUCCESS = 'ADD_WORK_ORDER_SUCCESS';
export const UPDATE_WORK_ORDER_START = 'UPDATE_WORK_ORDER_START';
export const UPDATE_WORK_ORDER_FAIL = 'UPDATE_WORK_ORDER_FAIL';
export const UPDATE_WORK_ORDER_SUCCESS = 'UPDATE_WORK_ORDER_SUCCESS';
